import React from "react";
import "../styles/Root.css";
import { GrPersonalComputer } from "react-icons/gr";
import { CgWebsite } from "react-icons/cg";
import { AiOutlineFileSearch } from "react-icons/ai";
import { FcMultipleDevices } from "react-icons/fc";
import { SiAffinitydesigner } from "react-icons/si";
import { FaShareAltSquare } from "react-icons/fa";

const Service = () => {
  return (
    <section className="services" id="service">
      <div className="container pt-8">
        <div className="about-me-text mt-5 text-center position-relative">
          <h1 className="position-absolute know-text">What I Do ?</h1>
          <h1 className="about-me-txt text-muted">Services</h1>
        </div>

        <div className="row mt-5">
          {/* ==================1=========== */}
          <div className="col-md-6">
            {/* ==============inner--col-1=========== */}
            <div className="inner-col">
              <div className="icons">
                <GrPersonalComputer />
              </div>
              <div className="text-col ">
                <h2 className="text-light">Frontend Development</h2>
                <p className="text-muted mt-2">
                "Elevate online presence with seamless, user-friendly websites. Expert frontend development.
                </p>
              </div>
            </div>
            {/* =================inner-col-2============= */}
            <div className="inner-col">
              <div className="icons">
                <AiOutlineFileSearch />
              </div>
              <div className="text-col ">
                <h2 className="text-light">SEO Friendly</h2>
                <p className="text-muted mt-2">
                Drive organic traffic, dominate rankings, and boost conversions with my SEO expertise.
                </p>
              </div>
            </div>
            {/* ==================INNER-COL-3================ */}
            <div className="inner-col">
              <div className="icons">
                <CgWebsite />
              </div>
              <div className="text-col ">
                <h2 className="text-light">Web Design</h2>
                <p className="text-muted mt-2">
                Modern, intuitive web design that captivates and converts visitors effortlessly.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            {/* ======================INNER-COL-4============== */}
            <div className="inner-col">
              <div className="icons">
                <SiAffinitydesigner />
              </div>
              <div className="text-col ">
                <h2 className="text-light">UI/UX Design</h2>
                <p className="text-muted mt-2">
                Sleek UI/UX design that enhances user engagement and delivers exceptional experiences."
                </p>
              </div>
            </div>
            {/* =====================INNER-COL-5=============== */}
            <div className="inner-col">
              <div className="icons">
                <FcMultipleDevices />
              </div>
              <div className="text-col ">
                <h2 className="text-light">Responsive Design</h2>
                <p className="text-muted mt-2">
                Create stunning, user-centric designs that look great on any screen size.
                </p>
              </div>
            </div>
            {/* ========================INNER-COL-6============== */}
            <div className="inner-col">
              <div className="icons">
                <FaShareAltSquare />
              </div>
              <div className="text-col ">
                <h2 className="text-light">Social Media Icons</h2>
                <p className="text-muted mt-2">
                Stand out with visually appealing social media icons that command attention.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;
